import * as React from 'react';
import { Check, ChevronsUpDown } from 'lucide-react';
import { cn } from '@/lib/utils';
import { Button } from '@/components/ui/button';
import { Command, CommandGroup, CommandList } from 'cmdk';
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from '@/components/ui/popover';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';

const frameworks = [
  {
    value: 'uz',
    short: "O'z",
    label: "O'zbekcha",
  },
  {
    value: 'cry',
    short: 'Кр',
    label: 'Кириллыча',
  },
  {
    value: 'kaa',
    short: 'Qa',
    label: 'Qaraqalpaqsha',
  },
  {
    value: 'en',
    short: 'En',
    label: 'English',
  },
  {
    value: 'ru',
    short: 'Ру',
    label: 'Русский',
  },
];

export function Language({ sidebarOpen }: { sidebarOpen: boolean }) {
  const { t, i18n } = useTranslation();
  const [open, setOpen] = React.useState(false);
  const { lang } = useParams();
  const [value, setValue] = React.useState(lang || 'uz');
  const navigate = useNavigate();

  React.useEffect(() => {
    if (lang && lang !== i18n.language) {
      i18n.changeLanguage(lang);
      setValue(lang);
    }
  }, [lang, i18n]);

  const onClick = (newLang: string) => {
    const pathParts = window.location.pathname.split('/');
    if (pathParts.length > 1) {
      pathParts[1] = newLang;
    }
    const newPath = pathParts.join('/');
    setOpen(false);
    navigate(newPath);
  };
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button
          variant="ghost"
          role="combobox"
          aria-expanded={open}
          className="w-full justify-between !bg-white_5 border-0 text-white hover:bg-transparent hover:text-white"
        >
          {value
            ? sidebarOpen
              ? frameworks.find((framework) => framework.value === value)?.label
              : frameworks.find((framework) => framework.value === value)?.short
            : 'Select framework...'}
          <ChevronsUpDown className="opacity-50 w-4 h-4" />
        </Button>
      </PopoverTrigger>
      <PopoverContent
        className={cn(' p-1', sidebarOpen ? 'w-[200px]' : 'w-[90px]')}
      >
        <Command>
          <CommandList>
            <CommandGroup>
              {frameworks.map((framework, i) => (
                <Button
                  variant="ghost"
                  key={framework.value}
                  onClick={() => onClick(framework.value)}
                  className={cn(
                    'w-full flex items-center justify-between text-sm cursor-pointer',
                  )}
                >
                  {sidebarOpen ? framework.label : framework.short}
                  <Check
                    className={cn(
                      'ml-auto w-4 h-4',
                      value === framework.value ? 'opacity-100' : 'opacity-0',
                    )}
                  />
                </Button>
              ))}
            </CommandGroup>
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
}
